import { useEffect, useRef, useState } from "react";

const anyPricePositive = (locs = []) => locs?.some(l => Number(l.price) > 0);

export default function useSilentPricePoll({ authAxios, adid, initialData }) {
  const [readyData, setReadyData] = useState(null);
  const started = useRef(false);
  const stopAt = useRef(Date.now() + 2 * 60 * 1000); // stop after 2 min
  const controllerRef = useRef(null);

  useEffect(() => {
    // start only if initialData exists AND prices are not ready yet
    if (!initialData || anyPricePositive(initialData.locations) || started.current) return;
    started.current = true;

    let timer;
    const interval = 2000;

    const tick = async () => {
      if (Date.now() > stopAt.current) return; // give up silently
      if (document.hidden) { timer = setTimeout(tick, interval); return; }

      try {
        controllerRef.current?.abort();
        controllerRef.current = new AbortController();
        const url = adid ? `/location/ad/${adid}` : `/location`;
        const r = await authAxios.get(url, { signal: controllerRef.current.signal });
        const data = r.data?.data;
        if (data && anyPricePositive(data.locations)) {
          setReadyData(data);  // <-- only fires once, then we stop
          return;
        }
      } catch {/* ignore and keep polling */}
      timer = setTimeout(tick, interval);
    };

    tick();
    return () => {
      controllerRef.current?.abort();
      clearTimeout(timer);
    };
  }, [authAxios, adid, initialData]);

  return readyData; // null until prices are ready
}